import {
  fetchBasedCall,
  type IHttpCall,
  type IHttpRequest,
  type IHttpResponse,
} from '@hc-frontend/core-utils-net';

import { UpdateProspectDto } from '../../dto';

type CreateProspectOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
};

export async function updateProspectService(
  baseUrl: string,
  body: UpdateProspectDto,
  options?: CreateProspectOptions,
): Promise<IHttpResponse<undefined>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options ?? {};

  const request: IHttpRequest<UpdateProspectDto> = {
    url: `${baseUrl}/api/v2/prospects/`,
    method: 'POST',
    headers,
    body,
    schemas: {
      request: UpdateProspectDto,
      response: undefined,
    },
    ...restOptions,
  };

  return httpCall(request);
}
